export const comments_3324450 = {"data":{"data":[],"links":{}}}